export default __webpack_public_path__ + "static/logo-297c0766d86b677ab36b388e8bfdfca0.png";